<div class="main">
  <div [style.flex-grow]="1"></div>
  <vmb-bankid
    mode="login"
    [audience]="environment.audience"
    [bankIdUrl]="environment.bankIdGatewayUrl"
    (accessToken)="service.login($event)"
  ></vmb-bankid>
  <div [style.flex-grow]="1"></div>
</div>
